module.exports = [{
      plugin: require('/builds/lynchburg/younicon-studio-web/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"","head":true},
    },{
      plugin: require('/builds/lynchburg/younicon-studio-web/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
